import Cookie from 'js-cookie'

export default class UserTracking {
  constructor() {
    this.setCookie()
  }

  setCookie() {
    const { pathname } = window.location
    const path = pathname == '/' ? 'homepage' : pathname
    const savedPath = Cookie.get('userPath')

    if (savedPath) Cookie.set('userPath', `${savedPath} -> ${path}`)
    if (!savedPath) Cookie.set('userPath', path)
  }
}
